import usdg from "assets/img/icons/usdg.svg";

type SingleStablecoin = {
  symbol: string;
  icon: string;
};

// Chains where the IDO accepts a single stablecoin (backend sets
// usdtAddress === usdcAddress), so the USDT/USDC selector is hidden and the
// UI shows this token's symbol/icon instead.
const SINGLE_STABLECOIN_BY_CHAIN: Record<number, SingleStablecoin> = {
  4663: { symbol: "USDG", icon: usdg }, // Robinhood Chain
};

// Chains that hide the selector but keep the default USDT/USDC labels.
const HIDE_SELECTOR_CHAINS = new Set<number>([80094]); // Berachain

export const getSingleStablecoin = (
  chainId?: number | null
): SingleStablecoin | null =>
  (chainId && SINGLE_STABLECOIN_BY_CHAIN[chainId]) || null;

export const shouldHideStablecoinSelector = (chainId?: number | null) =>
  !!chainId &&
  (HIDE_SELECTOR_CHAINS.has(chainId) || !!getSingleStablecoin(chainId));

export const getStablecoinLabel = (
  chainId: number | null | undefined,
  buyForUsdt: boolean
): string =>
  getSingleStablecoin(chainId)?.symbol ?? (buyForUsdt ? "USDT" : "USDC");

export const getStablecoinIcon = (
  chainId: number | null | undefined,
  fallbackIcon: string
): string => getSingleStablecoin(chainId)?.icon ?? fallbackIcon;
